import api from "../../base/api";
import http from 'axios'
import Optional from "optional-js"

var Domain = BASE_URL;

var pim = {};

pim._validateRes = (res) => {

    return res && res.data.code == "00" && res.data.result;
}


pim._groupmap = (_gpname) => {



}

pim._checkPro = (me, pro) => {
    return me && me[pro];
}


pim._checkFilterPath = (_path) => {

    var path = "/content/sonystyle/products/ilc/";
    if (/ilc_app/i.test(_path)) {
        path = "/content/sonystyle/products/ilc/";
    }



    return path;

}

/**
 * judge the empty : result.levelOneItems.length<1
 * @param {} _path
 */
pim.filterList = async (_path) => {
    "use strict";
    let url = api.search.filter();
    let fitrst = {};
    try {
        let res = await http.get(url + pim._checkFilterPath(_path));
        if (res && res.data && res.data.resultData) {
            fitrst = res.data.resultData;
        }

    } catch (err) {
        console.log(err);
    }

    // console.log(JSON.stringify(fitrst))

    return fitrst;
}

/**
 *
 * @param {*} _path
 * @param {*} _needAddBase
 */
pim.seriesList = async (_path, _needAddBase) => {

    "use strict";
    let url = api.search.list();
    let result = {}
    // let seris = {};
    //alert(_path);

    try {
        if (_path && _path.length > 0) {

            let seris = {};


            let res = await http.get(url, { params: { path: _path } });
            if (res && res.data && res.data.resultData) {
                seris = res.data.resultData;

                if (seris.length > 0) {

                    await Promise.all(seris.map(async (single) => {

                        if (single.items) {
                            await Promise.all(single.items.map(async (it) => {
                                if (it.eightd) {

                                    let md = await pim.getMasterWithPrice(it.eightd.split(",").pop());

                                    if (md.imagePath) {
                                        if (_needAddBase) {
                                            it.imagePath = BASE_URL + md.imagePath;
                                        } else {
                                            it.imagePath = md.imagePath;
                                        }
                                    }//end

                                    if (md.price) {
                                        it.price = md.price;
                                    } else if (md.srp) {
                                        it.price = md.price;
                                    }



                                    Optional.ofNullable(md.mapOne).ifPresent(one => {
                                        it.mapOne = one;
                                    })

                                    // if (md.mapOne) {
                                    //     it.mapOne = md.mapOne;
                                    // }

                                }


                            }));//promise all
                        }

                    }));



                }//end of seris process
                result.series = seris;
            }//end for return data


            Optional.ofNullable(res).map(d => { return d.data; }).map(m => { return m.filterData }).ifPresent(d => {
                result.filters = d;
            });




        }//end of path


    } catch (err) {
        console.log(err);
    }



    return result;


}

/**
 *
 */
pim.categoryList = async (_needAddBase) => {


    "use strict";
    let url = api.search.category();
    let lst = {};
    try {

        let res = await http.get(url);
        if (res && res.data && res.data.resultData) {
            lst = res.data.resultData;

            if (_needAddBase == true && lst.length > 0) {

                lst.filter(t => {
                    return t.series && t.series.length > 0;
                }).forEach(et => {
                    //why I need to add filter?
                    et.filter = true;

                    et.series.filter(e => {
                        return e.items && e.items.length > 0;
                    }).forEach(ss => {

                        ss.items.forEach(it => {
                            Optional.ofNullable(it.image).ifPresent(img => {
                                it.image = BASE_URL + img;
                            })
                            // if (it.image) {
                            //     it.image = BASE_URL + it.image;
                            // }
                        })

                    });

                })
            }
        }

    } catch (err) {
        console.log(err);
    }

    return lst;

}

/**
 *
 * @param {*} _8d
 */
pim.getAccessory = async (_8d) => {

    "use strict";
    let url = api.product.findProductAccessory();

    let pd = {};

    try {

        let res = await http.get(url, { params: { eightD: _8d } });

        if (res && res.data && res.data.code == "00") {
            pd = res.data.returnData;
        }


    } catch (err) {

        console.log(err);
    }

    return pd;



}


/**
 *
 * @param {*} _8d
 */
pim.getProductDetail = async (_8d) => {

    "use strict";
    let url = api.search.findPdpPath();

    let pd = {};
    try {
        let res = await http.get(url + _8d);
        if (res.data && res.data[0] && res.data[0].result) {

            let path = res.data[0].result;

            let pdpurl = api.search.findPDP() + path;

            let dt = await http.get(pdpurl);

            if (dt.data && dt.data.resultData) {



                pd = dt.data.resultData;
                pd.hasDetail = true;

                if (pd.specifications && pd.specifications.length > 0) {
                    pd.specifications.forEach(element => {
                        if (element.eightd && element.eightd.indexOf(_8d) > -1) {

                            pd.currentBundle = element;
                        }
                    });
                }
            }

            //TODO:

        }

    } catch (err) {
        console.log(err);
    }

    return pd;

}


/**
 * product.mapOne
 * product.mapOne is map,that contains sub maps.
 * So you can consider, mapOne is level one fitler and the related sub maps are level two's
 * these two level maps for fitler
 *
 *
 */
pim.getMaster = async (_8d, _needDomain) => {

    "use strict";
    let pd = {};
    let url = api.product.findMasterData();

    try {

        let res = await http.get(url, { params: { eightD: _8d } });
        if (pim._validateRes(res)) {
            if (res && res.data && res.data.returnData && res.data.returnData.OutMasterData) {
                pd = res.data.returnData.OutMasterData;
            }
        }

        // alert(Domain)
        if (_needDomain && pd.colorImage && pd.colorImage.indexOf("http") < 0) {

            pd.colorImage = Domain + pd.colorImage;
        }

        if (_needDomain && pd.imagePath && pd.imagePath.indexOf("http") < 0) {
            pd.imagePath = Domain + pd.imagePath;
            // alert(pd.imagePath)
        }

        if (pd.filterLevelOneRefs && pd.filterLevelOneRefs.length > 0) {
            let mapOne = new Map();
            pd.mapOne = mapOne;

            pd.filterLevelOneRefs.forEach(one => {
                if (!mapOne.has(one.cnName)) {
                    mapOne.set(one.cnName, new Map());
                }

                let mapTwo = mapOne.get(one.cnName);

                Optional.ofNullable(one.filterLevelTwoRefs).filter(two => {
                    return two.length > 0;
                }).ifPresent(two => {
                    two.map(me => {
                        Optional.ofNullable(me).filter(m => pim._checkPro(m, "cnName")).filter(m => {
                            return me.isChecked && me.isChecked === "true";
                        }).ifPresent(me => {
                            mapTwo.set(me.cnName, true);
                        })
                    })
                });

            });

            // console.log("PD work is ",JSON.stringify(pd));


        }



    } catch (err) {
        console.log(err);
    }

    return pd;

}


/**
 * Get the product master data from PIM, as well as the member price
 * Notice:
 * pd.imagePath, is for product image on AEM
 * pd.srp, the SRP price
 * pd.price, the member price
 *
 * @param {*} _8d the product 8D code,that is mandory
 * @param {*} _group the member group
 */
pim.getMasterWithPrice = async (_8d, _group) => {

    "use strict";
    let pd = {};
    let url = api.product.findMasterData();



    try {

        pd = await pim.getMaster(_8d);

        let gp = "";
        if (_group && _group != "") {
            gp = _group;
        } else {


          switch (localStorage.getItem("member_group")) {
            case 'registergroup':
              gp = 'ZT01';
              break;
            case 'bronzegroup':
              gp = 'ZT02';
              break;
            case 'silvergroup':
              gp = 'ZT11';
              break;
            case 'goldgroup':
              gp = 'ZT12';
              break;
            default:
              break;

          }
        }

        // console.log("member_group is ", gp);
        //console.log("Product SKU 8D is ",JSON.stringify(pd));

        if (pd.sku8D) {

            let prcAPI = api.b2c.singlePrice();

            var ps = {
                eightcode: _8d,
                channel: "WAP",
                basestore: "SS",
                pval: gp
            };

            var pcs = await http.post(prcAPI, JSON.stringify(ps));

           // Optional.ofNullable(pcs).filter(pim._checkPro)

            if (pcs && pcs.data && pcs.data.returncode == "200") {

                if (pcs.data.data && pcs.data.data.productprice) {
                  pd.productprice = pcs.data.data.productprice;
                    if (pcs.data.data.productprice.srp) {
                        pd.srp = pcs.data.data.productprice.srp;
                    }

                    if (pcs.data.data.productprice.price) {
                        pd.price = pcs.data.data.productprice.price;
                    }
                    if (pcs.data.data.cartpromotelist) {
                        pd.cartpromotelist = pcs.data.data.cartpromotelist;
                    }
                    if (pcs.data.data.promotelist) {
                      pd.promotelist = pcs.data.data.promotelist;
                    }

                }
            }
            // console.log("price is ",JSON.stringify(pcs));

        }




    } catch (err) {
        console.log(err);
    }

    return pd;



}

/**
 * find the main specification
 *
 * @param {the product code} _8d
 */
pim.getMainSpec = async (_8d) => {

    "use strict";
    let url = api.product.findDetailSpec();

    let spec = {};

    try {

        let res = await http.get(url, { params: { eightD: _8d } });
        if (res && res.data && res.data.code == "00") {
            spec = res.data.returnData;
        }

    } catch (err) {
        console.log(err);
    }

    return spec;

}

export default pim;



// WEBPACK FOOTER //
// ./src/commons/utils/pim.js